"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickEventLabel = void 0;
var ClickEventLabel;
(function (ClickEventLabel) {
    ClickEventLabel["PROFILE"] = "Profile";
    ClickEventLabel["LOGIN"] = "Login";
    ClickEventLabel["REGISTRATION"] = "Registration";
    ClickEventLabel["GO_TO_LOGIN"] = "Go to login";
    ClickEventLabel["ACCEPT_TERMS_AND_CONDITIONS"] = "AcceptTermsAndConditions";
    ClickEventLabel["SIGNUP"] = "Sign Up";
    ClickEventLabel["RESEND_CONFIRMATION_MAIL"] = "ResendConfirmationMail";
    ClickEventLabel["FORGOT_PASSWORD"] = "ForgotPassword";
    ClickEventLabel["CHECK_FINAL_CONFIRMATION_MAIL"] = "CheckFinalConfirmationMail";
    ClickEventLabel["GO_TO_REGISTRATION"] = "Go to Registration";
    ClickEventLabel["COMPLETE_PROFILE"] = "CompleteProfile";
    ClickEventLabel["SEND_NEW_PASSWORD"] = "SendNewPassword";
    ClickEventLabel["BACK"] = "Back";
    ClickEventLabel["RESEND_PASSWORD_MAIL"] = "ResendPasswordMail";
    ClickEventLabel["RESET_PASSWORD"] = "ResetPassword";
    ClickEventLabel["LOGOUT"] = "Logout";
    ClickEventLabel["MY_PROFILE"] = "My Profile";
    ClickEventLabel["SETTINGS"] = "Settings";
    ClickEventLabel["MY_WISHLIST"] = "My wishlist";
    ClickEventLabel["MY_ORDERS"] = "My orders";
    ClickEventLabel["REDEEM_YOUR_VOUCHER"] = "Redeem your voucher";
    ClickEventLabel["VOUCHER_VALIDITY"] = "Voucher validity";
    ClickEventLabel["MR"] = "Mr";
    ClickEventLabel["MRS"] = "Mrs";
    ClickEventLabel["DIVERSE"] = "Diverse";
    ClickEventLabel["UPDATE_NOW"] = "Update now";
    ClickEventLabel["CHANGE_PASSWORD"] = "Change password";
    ClickEventLabel["DELETE_ACCOUNT"] = "Delete account";
    ClickEventLabel["RESEND_DELETION_CONFIRMATION_MAIL"] = "ResendDeletionConfirmationMail";
    ClickEventLabel["HELP_ACCOUNT_DELETION"] = "HelpAccountDeletion";
    ClickEventLabel["OVERVIEW"] = "Overview";
    ClickEventLabel["LOGO"] = "Logo";
    ClickEventLabel["PAYBACK"] = "Payback";
    ClickEventLabel["CART"] = "Cart";
    ClickEventLabel["CONTACT"] = "Contact";
    ClickEventLabel["TRUSTED_SHOP"] = "Trusted shop";
})(ClickEventLabel || (exports.ClickEventLabel = ClickEventLabel = {}));
//# sourceMappingURL=ClickEventLabel.js.map